<script>
export default {
    name: 'redirecionar-usuario-inativo',
    async created() {
        window.location.assign(`${window.location.origin}${window.location.pathname}usuario-inativo.html`)
    }
}
</script>